import DOMPurify from 'dompurify';

export const isQuillEmpty = (value?: string): boolean => {
  if (!value) return true;

  const emptyStates = ['<p><br></p>', '<p></p>'];

  if (emptyStates.includes(value)) return true;

  const textContent = value.replace(/<[^>]*>/g, '').trim();
  return textContent === '';
};

export const sanitizeRichText = (html?: string): string => {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'em',
      'u',
      's',
      'a',
      'ul',
      'ol',
      'li',
      'h1',
      'h2',
      'h3',
      'blockquote',
      'code',
      'pre',
      'img',
      'span',
      'div',
      'sub',
      'sup',
    ],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'style', 'class', 'align', 'color', 'background'],
  });
};
